import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class SidenavStore {
    private sidenavState = signal(true);

    constructor() { }

    get sidenavOpen() {
        return this.sidenavState();
    }

    // Getter pour savoir si le sidenav est ouvert
    getSidenavState() {
        return this.sidenavState;
    }

    // Méthode pour ouvrir la sidenav
    openSidenav() {
        this.sidenavState.set(true);
    }

    // Méthode pour fermer la sidenav
    closeSidenav() {
        this.sidenavState.set(false);
    }

    // Méthode pour toggle la sidenav
    toggleSidenav() {
        this.sidenavState.set(!this.sidenavState());
    }
}
